var render, staticRenderFns
import script from "./CategoryArticleFieldComponent.vue?vue&type=script&lang=js&"
export * from "./CategoryArticleFieldComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/releases/338/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('059d8b36')) {
      api.createRecord('059d8b36', component.options)
    } else {
      api.reload('059d8b36', component.options)
    }
    
  }
}
component.options.__file = "resources/js/pages/components/fields/CategoryArticleFieldComponent.vue"
export default component.exports